import React, { ReactNode } from "react";
import { useDialogService } from "./useDialogService";
import { DialogServiceContext } from "./DialogServiceContext";

export const DialogServiceContextWrapper = ({ children }: { children: ReactNode }) => {
  const dialogService = useDialogService();

  return (
    <DialogServiceContext.Provider value={{ show: dialogService.show }}>
      {dialogService.dialogBody}
      {children}
    </DialogServiceContext.Provider>
  );
};
